import { useMemo } from "react";
import { Route } from "react-router-dom";
import { TabLayout } from "../../ui_elements";

export const ReportsRouter = ({
	component,
	path,
	exact,
	purpose,
	title,
	user,
	...rest
}) => {
	const Component = component;
	const paths = useMemo(
		() => [
			{
				title: "Payment Reports",
				path: "/reports/payment_reports",
				disabled: false
			},
			{
				title: "Application Reports",
				path: "/reports/application_reports",
				disabled: false
			},
			{
				title: "Bursary Reports",
				path: "/reports/bursary",
				disabled: false
			},
			{
				title: "Registration Number Reports",
				path: "/reports/registration_number_reports",
				disabled: false
			},
			{
				title: "Hostel Reports",
				path: "/reports/hostel_reports",
				disabled: false
			},
			{
				title: "Hostel Summary Reports",
				path: "/reports/hostel_summary_reports",
				disabled: false
			}
		],
		[]
	);
	return (
		<Route
			exact={exact}
			path={path}
			{...rest}
			render={(props) => {
				return (
					<TabLayout title={title} paths={paths}>
						<Component {...rest} {...props} />
					</TabLayout>
				);
			}}
		/>
	);
};
